import { render, staticRenderFns } from "./menuTemplate.vue?vue&type=template&id=42b5d9ba&scoped=true&"
import script from "./menuTemplate.vue?vue&type=script&lang=js&"
export * from "./menuTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5d9ba",
  null
  
)

export default component.exports